<template lang="html">
  <div class="p-currency">
    <CommonHeader class="header">
      {{ $t('currency.my') }}
      <RouterLink slot="left" to="/profile">
        <svg class="m-style-svg m-svg-def">
          <use xlink:href="#icon-back" />
        </svg>
      </RouterLink>
      <RouterLink
        slot="right"
        to="/currency/exchange"
      >
        {{ $t('currency_rules.exchange') }}
      </RouterLink>
    </CommonHeader>

    <section class="m-currency-panel">
      <h3>{{ $t('currency.current') }}</h3>
      <div class="flex-currency">
        <p>
          {{ user.currency.sum || 0 }}
          <img class="goldscore" src="./img/score.png">
        </p>
        <span class="rules" @click="showRule">
          <svg class="m-style-svg m-svg-small">
            <use xlink:href="#icon-wallet-warning" />
          </svg>
          {{ $t('currency.rule') }}
        </span>
      </div>
    </section>
    <JoLoadMore
      ref="loadmore"
      class="m-currency-list"
      @onLoadMore="onLoadMore"
      @onRefresh="onRefresh"
    >
      <CurrencyDetailItem
        v-for="item in list"
        v-if="item.id"
        :key="item.id"
        :nostyle="true"
        :detail="item"
        type="title"
      />
    </JoLoadMore>

    <ul class="m-box-model m-entry-group padding">
      <!-- <RouterLink
        v-if="currency.recharge.status"
        to="/currency/recharge"
        tag="li"
        class="m-entry"
      >
        <svg class="m-style-svg m-svg-def m-entry-prepend">
          <use xlink:href="#icon-currency-recharge" />
        </svg>
        <span class="m-text-box m-flex-grow1">{{ $t('currency.recharge.name') }}</span>
        <svg class="m-style-svg m-svg-def m-entry-append">
          <use xlink:href="#icon-arrow-right" />
        </svg>
      </RouterLink> -->
      <!-- <RouterLink
        v-if="currency.cash.status"
        to="/currency/withdraw"
        tag="li"
        class="m-entry"
      >
        <svg class="m-style-svg m-svg-def m-entry-prepend">
          <use xlink:href="#icon-profile-wallet" />
        </svg>
        <span class="m-text-box m-flex-grow1">{{ $t('currency.withdraw.name') }}</span>
        <svg class="m-style-svg m-svg-def m-entry-append">
          <use xlink:href="#icon-arrow-right" />
        </svg>
      </RouterLink> -->
    </ul>

    <DetailAd type="currency" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import DetailAd from '@/components/advertisement/DetailAd.vue'
  import CurrencyDetailItem from './components/CurrencyDetailItem.vue'

  export default {
    name: 'Currency',
    components: { DetailAd, CurrencyDetailItem },
    data () {
      return {
        fromPageTitle: '',
        list: [],
        currInfo: null,
      }
    },
    computed: {
      ...mapState({
        user: 'CURRENTUSER',
        currency: state => state.CONFIG.currency,
      }),
      rule () {
        const rule = this.currency.rule || ''
        return rule.replace(/\n/g, '<br>')
      },
      after () {
        const len = this.list.length
        return len ? this.list[len - 1].id : 0
      },
      currAction: {
        get () {
          return this.$route.query.action || 'recharge'
        },
        set (val) {
          this.$router.replace({
            path: this.$route.path,
            query: { action: val },
          })
        },
      },
    },
    watch: {
      currAction () {
        this.list = []
        this.$refs.loadmore.beforeRefresh()
      },
    },
    created () {
      this.fromPageTitle = document.title
      document.title = this.currencyUnit
    },
    mounted () {
      this.$store.dispatch('fetchUserInfo')

      const amount = this.$route.query.total_amount
      if (amount) {
        this.$Message.success(this.$t('currency.success', [amount * 100]))
      }
    },
    destroyed () {
      document.title = this.fromPageTitle
    },
    methods: {
      showRule () {
        this.$router.push({ path: '/currency/rules' })
        // this.$bus.$emit('popupDialog', {
        //   title: `${this.$t('currency.rule')}`,
        //   content: this.rule,
        // })
      },
      async onRefresh () {
        const data = await this.$store.dispatch('currency/getCurrencyOrders')
        if (data.length > 0) this.list = _.unionBy([...data, ...this.list], 'id')

        this.$refs.loadmore.afterRefresh(data.length < 15)
      },
      async onLoadMore () {
        const data = await this.$store.dispatch('currency/getCurrencyOrders', {
          after: this.after,
        })
        if (data.length > 0) {
          this.list = [...this.list, ...data]
        }
        this.$refs.loadmore.afterLoadMore(data.length < 15)
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./currency.less";
.goldscore {
  width: 37px;
  height: 45px;
}
.header {
  position: relative;
  background: linear-gradient(347deg, #31a8ef 0%, #00aeef 100%)
}
</style>
